import { h, resolveComponent } from 'vue';
import MainPage from '../views/MainPage.vue';

export default [{
  path: '/:locale/golf-courses',
  component: {
    render() { return h(resolveComponent('router-view')); },
  },
  children: [{
    path: '',
    name: 'MainPage',
    component: MainPage,
  }, {
    path: '/:locale/:path/:pathMatch(.*)*',
    redirect: (to) => ({ name: 'MainPage', params: { locale: to.params.locale } }),
  }],
}];
